/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequest,
    BadRequestFromJSON,
    BadRequestToJSON,
    EmailMessage,
    EmailMessageFromJSON,
    EmailMessageToJSON,
    EmailNotification,
    EmailNotificationFromJSON,
    EmailNotificationToJSON,
    Forbidden,
    ForbiddenFromJSON,
    ForbiddenToJSON,
    InternalServerError,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    NotFound,
    NotFoundFromJSON,
    NotFoundToJSON,
} from '../models';

export interface CreateEmailNotificationRequest {
    emailNotification: EmailNotification;
    metaformId: string;
}

export interface DeleteEmailNotificationRequest {
    metaformId: string;
    emailNotificationId: string;
}

export interface FindEmailNotificationRequest {
    metaformId: string;
    emailNotificationId: string;
}

export interface ListEmailNotificationsRequest {
    metaformId: string;
}

export interface SendMetaformEmailRequest {
    emailMessage: EmailMessage;
    metaformId: string;
}

export interface UpdateEmailNotificationRequest {
    emailNotification: EmailNotification;
    metaformId: string;
    emailNotificationId: string;
}

/**
 * 
 */
export class EmailNotificationsApi extends runtime.BaseAPI {

    /**
     * Creates new email notification  Method is allowed only for system administrators and metaform administrators 
     * create new form email notification
     */
    async createEmailNotificationRaw(requestParameters: CreateEmailNotificationRequest): Promise<runtime.ApiResponse<EmailNotification>> {
        if (requestParameters.emailNotification === null || requestParameters.emailNotification === undefined) {
            throw new runtime.RequiredError('emailNotification','Required parameter requestParameters.emailNotification was null or undefined when calling createEmailNotification.');
        }

        if (requestParameters.metaformId === null || requestParameters.metaformId === undefined) {
            throw new runtime.RequiredError('metaformId','Required parameter requestParameters.metaformId was null or undefined when calling createEmailNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json;charset=utf-8';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/metaforms/{metaformId}/emailNotifications`.replace(`{${"metaformId"}}`, encodeURIComponent(String(requestParameters.metaformId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailNotificationToJSON(requestParameters.emailNotification),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailNotificationFromJSON(jsonValue));
    }

    /**
     * Creates new email notification  Method is allowed only for system administrators and metaform administrators 
     * create new form email notification
     */
    async createEmailNotification(requestParameters: CreateEmailNotificationRequest): Promise<EmailNotification> {
        const response = await this.createEmailNotificationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates new email notification  Method is allowed only for system administrators and metaform administrators 
     * create new form email notification
     */
    async createEmailNotificationWithHeaders(requestParameters: CreateEmailNotificationRequest): Promise<[ EmailNotification, Headers ]> {
        const response = await this.createEmailNotificationRaw(requestParameters);
        const value = await response.value(); 
        return [ value, response.raw.headers ];
    }

    /**
     * Deletes email notification  Method is allowed only for system administrators and metaform administrators 
     * Deletes an email notification
     */
    async deleteEmailNotificationRaw(requestParameters: DeleteEmailNotificationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.metaformId === null || requestParameters.metaformId === undefined) {
            throw new runtime.RequiredError('metaformId','Required parameter requestParameters.metaformId was null or undefined when calling deleteEmailNotification.');
        }

        if (requestParameters.emailNotificationId === null || requestParameters.emailNotificationId === undefined) {
            throw new runtime.RequiredError('emailNotificationId','Required parameter requestParameters.emailNotificationId was null or undefined when calling deleteEmailNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/metaforms/{metaformId}/emailNotifications/{emailNotificationId}`.replace(`{${"metaformId"}}`, encodeURIComponent(String(requestParameters.metaformId))).replace(`{${"emailNotificationId"}}`, encodeURIComponent(String(requestParameters.emailNotificationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes email notification  Method is allowed only for system administrators and metaform administrators 
     * Deletes an email notification
     */
    async deleteEmailNotification(requestParameters: DeleteEmailNotificationRequest): Promise<void> {
        await this.deleteEmailNotificationRaw(requestParameters);
    }

    /**
     * Deletes email notification  Method is allowed only for system administrators and metaform administrators 
     * Deletes an email notification
     */
    async deleteEmailNotificationWithHeaders(requestParameters: DeleteEmailNotificationRequest): Promise<Headers> {
        const response = await this.deleteEmailNotificationRaw(requestParameters);
        return response.raw.headers;
    }

    /**
     * Finds email notification  Method is allowed only for system administrators and metaform administrators 
     * Find a single email notification
     */
    async findEmailNotificationRaw(requestParameters: FindEmailNotificationRequest): Promise<runtime.ApiResponse<EmailNotification>> {
        if (requestParameters.metaformId === null || requestParameters.metaformId === undefined) {
            throw new runtime.RequiredError('metaformId','Required parameter requestParameters.metaformId was null or undefined when calling findEmailNotification.');
        }

        if (requestParameters.emailNotificationId === null || requestParameters.emailNotificationId === undefined) {
            throw new runtime.RequiredError('emailNotificationId','Required parameter requestParameters.emailNotificationId was null or undefined when calling findEmailNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/metaforms/{metaformId}/emailNotifications/{emailNotificationId}`.replace(`{${"metaformId"}}`, encodeURIComponent(String(requestParameters.metaformId))).replace(`{${"emailNotificationId"}}`, encodeURIComponent(String(requestParameters.emailNotificationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailNotificationFromJSON(jsonValue));
    }

    /**
     * Finds email notification  Method is allowed only for system administrators and metaform administrators 
     * Find a single email notification
     */
    async findEmailNotification(requestParameters: FindEmailNotificationRequest): Promise<EmailNotification> {
        const response = await this.findEmailNotificationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Finds email notification  Method is allowed only for system administrators and metaform administrators 
     * Find a single email notification
     */
    async findEmailNotificationWithHeaders(requestParameters: FindEmailNotificationRequest): Promise<[ EmailNotification, Headers ]> {
        const response = await this.findEmailNotificationRaw(requestParameters);
        const value = await response.value(); 
        return [ value, response.raw.headers ];
    }

    /**
     * Lists email notifications for the form  Method is allowed only for system administrators and metaform administrators 
     * Lists form email notifications
     */
    async listEmailNotificationsRaw(requestParameters: ListEmailNotificationsRequest): Promise<runtime.ApiResponse<Array<EmailNotification>>> {
        if (requestParameters.metaformId === null || requestParameters.metaformId === undefined) {
            throw new runtime.RequiredError('metaformId','Required parameter requestParameters.metaformId was null or undefined when calling listEmailNotifications.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/metaforms/{metaformId}/emailNotifications`.replace(`{${"metaformId"}}`, encodeURIComponent(String(requestParameters.metaformId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmailNotificationFromJSON));
    }

    /**
     * Lists email notifications for the form  Method is allowed only for system administrators and metaform administrators 
     * Lists form email notifications
     */
    async listEmailNotifications(requestParameters: ListEmailNotificationsRequest): Promise<Array<EmailNotification>> {
        const response = await this.listEmailNotificationsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Lists email notifications for the form  Method is allowed only for system administrators and metaform administrators 
     * Lists form email notifications
     */
    async listEmailNotificationsWithHeaders(requestParameters: ListEmailNotificationsRequest): Promise<[ Array<EmailNotification>, Headers ]> {
        const response = await this.listEmailNotificationsRaw(requestParameters);
        const value = await response.value(); 
        return [ value, response.raw.headers ];
    }

    /**
     * Sends a form-related email using the server-configured email provider.  Anonymous access is allowed only for public forms that allow anonymous responses. 
     * Sends a form email
     */
    async sendMetaformEmailRaw(requestParameters: SendMetaformEmailRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.emailMessage === null || requestParameters.emailMessage === undefined) {
            throw new runtime.RequiredError('emailMessage','Required parameter requestParameters.emailMessage was null or undefined when calling sendMetaformEmail.');
        }

        if (requestParameters.metaformId === null || requestParameters.metaformId === undefined) {
            throw new runtime.RequiredError('metaformId','Required parameter requestParameters.metaformId was null or undefined when calling sendMetaformEmail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json;charset=utf-8';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/metaforms/{metaformId}/email`.replace(`{${"metaformId"}}`, encodeURIComponent(String(requestParameters.metaformId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailMessageToJSON(requestParameters.emailMessage),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sends a form-related email using the server-configured email provider.  Anonymous access is allowed only for public forms that allow anonymous responses. 
     * Sends a form email
     */
    async sendMetaformEmail(requestParameters: SendMetaformEmailRequest): Promise<void> {
        await this.sendMetaformEmailRaw(requestParameters);
    }

    /**
     * Sends a form-related email using the server-configured email provider.  Anonymous access is allowed only for public forms that allow anonymous responses. 
     * Sends a form email
     */
    async sendMetaformEmailWithHeaders(requestParameters: SendMetaformEmailRequest): Promise<Headers> {
        const response = await this.sendMetaformEmailRaw(requestParameters);
        return response.raw.headers;
    }

    /**
     * Updates email notification  Method is allowed only for system administrators and metaform administrators 
     * Updates email notification
     */
    async updateEmailNotificationRaw(requestParameters: UpdateEmailNotificationRequest): Promise<runtime.ApiResponse<EmailNotification>> {
        if (requestParameters.emailNotification === null || requestParameters.emailNotification === undefined) {
            throw new runtime.RequiredError('emailNotification','Required parameter requestParameters.emailNotification was null or undefined when calling updateEmailNotification.');
        }

        if (requestParameters.metaformId === null || requestParameters.metaformId === undefined) {
            throw new runtime.RequiredError('metaformId','Required parameter requestParameters.metaformId was null or undefined when calling updateEmailNotification.');
        }

        if (requestParameters.emailNotificationId === null || requestParameters.emailNotificationId === undefined) {
            throw new runtime.RequiredError('emailNotificationId','Required parameter requestParameters.emailNotificationId was null or undefined when calling updateEmailNotification.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json;charset=utf-8';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/metaforms/{metaformId}/emailNotifications/{emailNotificationId}`.replace(`{${"metaformId"}}`, encodeURIComponent(String(requestParameters.metaformId))).replace(`{${"emailNotificationId"}}`, encodeURIComponent(String(requestParameters.emailNotificationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmailNotificationToJSON(requestParameters.emailNotification),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailNotificationFromJSON(jsonValue));
    }

    /**
     * Updates email notification  Method is allowed only for system administrators and metaform administrators 
     * Updates email notification
     */
    async updateEmailNotification(requestParameters: UpdateEmailNotificationRequest): Promise<EmailNotification> {
        const response = await this.updateEmailNotificationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Updates email notification  Method is allowed only for system administrators and metaform administrators 
     * Updates email notification
     */
    async updateEmailNotificationWithHeaders(requestParameters: UpdateEmailNotificationRequest): Promise<[ EmailNotification, Headers ]> {
        const response = await this.updateEmailNotificationRaw(requestParameters);
        const value = await response.value(); 
        return [ value, response.raw.headers ];
    }

}
